import { render, staticRenderFns } from "./Comunidad.vue?vue&type=template&id=122d30d6&"
import script from "./Comunidad.vue?vue&type=script&lang=js&"
export * from "./Comunidad.vue?vue&type=script&lang=js&"
import style0 from "./Comunidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports